import { useEffect, useState } from "react";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useSideOptions = () => {
  const [options, setOptions] = useState<string[]>([]);
  const { handle } = useMessageHandler();

  useEffect(() => {
    handle(async () => {
      const response = await apiJson.get("/mechanics/testpoints/sides");
      setOptions(response.data);
    });
  }, [handle]);

  return { options };
};